export function setTransfers(state, payload) {
  state.transfers = payload;
  state.transfer = null;
  state.error = false;
  state.errorMessage = "";
}

export function setTransfer(state, payload) {
  state.transfers = null;
  state.transfer = payload;
  state.error = false;
  state.errorMessage = "";
}

export function setSuccess(state, payload) {
  state.error = false;
  state.errorMessage = "";
  state.success = true;
  state.successMessage = payload;
}

export function setError(state, payload) {
  state.error = true;
  state.errorMessage = payload;
  state.success = false;
  state.successMessage = "";
}
